export default __webpack_public_path__ + "static/media/pic4.b8f1cb88.png";